import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-inform",
  "use": "icon-inform-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-inform\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512z m0-467.2L288 422.4v208c0 22.4 19.2 38.4 41.6 38.4h364.8c22.4 0 41.6-16 41.6-38.4v-208L512 556.8zM329.6 352c-22.4 0-38.4 16-41.6 35.2v3.2l224 134.4 224-134.4v-3.2c-3.2-19.2-19.2-35.2-41.6-35.2H329.6z\" p-id=\"3121\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/inform.svg
// module id = jBgF
// module chunks = 65